/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Compliance_EudataInputs */

const en_landing_compliance_eudata = /** @type {(inputs: Landing_Compliance_EudataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EU Data`)
};

const de_landing_compliance_eudata = /** @type {(inputs: Landing_Compliance_EudataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EU-Daten`)
};

const fr_landing_compliance_eudata = /** @type {(inputs: Landing_Compliance_EudataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EU Data`)
};

const es_landing_compliance_eudata = /** @type {(inputs: Landing_Compliance_EudataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EU Data`)
};

const it_landing_compliance_eudata = /** @type {(inputs: Landing_Compliance_EudataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EU Data`)
};

const nl_landing_compliance_eudata = /** @type {(inputs: Landing_Compliance_EudataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EU Data`)
};

const pl_landing_compliance_eudata = /** @type {(inputs: Landing_Compliance_EudataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EU Data`)
};

const fi_landing_compliance_eudata = /** @type {(inputs: Landing_Compliance_EudataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EU Data`)
};

const da_landing_compliance_eudata = /** @type {(inputs: Landing_Compliance_EudataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EU Data`)
};

const sv_landing_compliance_eudata = /** @type {(inputs: Landing_Compliance_EudataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EU Data`)
};

/**
* | output |
* | --- |
* | "EU Data" |
*
* @param {Landing_Compliance_EudataInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_compliance_eudata = /** @type {((inputs?: Landing_Compliance_EudataInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Compliance_EudataInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_compliance_eudata(inputs)
	if (locale === "fr") return fr_landing_compliance_eudata(inputs)
	if (locale === "es") return es_landing_compliance_eudata(inputs)
	if (locale === "it") return it_landing_compliance_eudata(inputs)
	if (locale === "nl") return nl_landing_compliance_eudata(inputs)
	if (locale === "pl") return pl_landing_compliance_eudata(inputs)
	if (locale === "fi") return fi_landing_compliance_eudata(inputs)
	if (locale === "da") return da_landing_compliance_eudata(inputs)
	if (locale === "sv") return sv_landing_compliance_eudata(inputs)
	return en_landing_compliance_eudata(inputs)
});